import { gql } from "graphql-request";
import { useMutation } from "react-query";
import QueryKeys from "../QueryKeys";
import { gqlClient } from "../../App";

function useDeleteApartment() {
  return useMutation(QueryKeys.DELETE_APARTMENT, async (input: String) => {
    return await gqlClient.request(
      gql`
        mutation DeleteApartment($input: String!) {
          deleteApartment(id: $input)
        }
      `,
      {
        input,
        operationName: QueryKeys.DELETE_APARTMENT,
      }
    );
  });
}

export default useDeleteApartment;
